<template>
    <v-card-actions>
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn v-on="on" v-bind="attrs" color="info" small @click="$emit('goBack')">
              <v-icon small left>mdi-exit-to-app</v-icon>
              <span class="text-overline">Voltar</span>
            </v-btn>              
          </template>
          <span>Voltar para Listagem</span>
        </v-tooltip>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn
              v-on="on" v-bind="attrs"
              color="success"
              :disabled="disabledSave"
              small
              @click.prevent="$emit('submitForm')">
              <v-icon small left>mdi-content-save</v-icon>
              <span class="text-overline">Salvar</span>
            </v-btn>              
          </template>
          <span>Salvar Novo Registro</span>
        </v-tooltip>           
    </v-card-actions>
</template>

<script>
export default {
    props:{
        disabledSave:{
            type:Boolean,
            default:false
        }
    }
}
</script>

<style>

</style>